import type { FC, ReactNode } from 'react';
export interface TrProps {
    className?: string;
    showHighlightMarker?: boolean;
    children?: ReactNode;
}

const Tr: FC<TrProps> = props => {
    const { children, className = '' } = props;

    return <tr className={`transition hover:bg-primary-100 dark:hover:bg-primary-900 ${className}`}>{children}</tr>;
};

export default Tr;
